import { motion } from "framer-motion";
import { ASSETS } from "@/constants/assets";

const ARCHETYPES = [
  {
    img: ASSETS.maleCable,
    title: "MEDICAL PRACTICES",
    subtitle: "Primary & Specialty Care",
    desc: "Streamline documentation, reduce after-hours work, and give clinicians multi-domain insight for faster, personalized plans.",
    tags: ["Digital Intake", "AI Summaries", "EHR Integration", "Analytics"],
  },
  {
    img: ASSETS.coupleTraining,
    title: "WELLNESS CENTERS",
    subtitle: "Longevity & Optimization",
    desc: "Unify metabolic health, hormone optimization, IV therapy, and recovery programs with standardized protocols across providers.",
    tags: ["Protocol Library", "Program Tracking", "Outcomes Analysis", "Multi-Site"],
  },
  {
    img: ASSETS.womenSquat,
    title: "HEALTH CLUBS & MSOs",
    subtitle: "Corporate & Multi-Location",
    desc: "Drive engagement across corporate wellness programs with clinical offerings, MSO-grade dashboards, and location comparison.",
    tags: ["Corporate Wellness", "MSO Analytics", "Scalable", "Role-Based"],
  },
];

export const ArchetypesSection = () => (
  <section id="archetypes" className="relative z-[1] py-28 lg:py-36 px-6 lg:px-12 overflow-hidden" data-testid="archetypes-section">
    <div className="logo-watermark-section">
      <img src={ASSETS.logo} alt="" className="logo-glow-intense" />
    </div>
    <div className="max-w-[1200px] mx-auto relative z-[2]">
      <motion.div
        className="bg-[rgba(3,11,24,0.92)] p-8 rounded-xl mb-12 max-w-[700px]"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
      >
        <div className="font-orbitron text-sm font-semibold tracking-[5px] uppercase text-[#60A5FA] mb-4 text-shadow">
          Solutions
        </div>
        <h2 className="font-orbitron text-3xl sm:text-4xl lg:text-5xl font-bold tracking-[3px] leading-tight mb-5 text-white text-shadow">
          Who We Serve
        </h2>
        <p className="font-outfit text-xl font-light leading-relaxed text-white/90">
          Independent practices, wellness centers, health clubs, and MSOs managing multi-site operations.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {ARCHETYPES.map((arch, i) => (
          <motion.div
            key={i}
            className="archetype-card border border-white/[0.08] rounded-lg overflow-hidden glass-light"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1 }}
            data-testid={`archetype-${i}`}
          >
            <div className="arch-img relative h-[300px] overflow-hidden">
              <img src={arch.img} alt={arch.title} className="w-full h-full object-cover object-top transition-transform duration-600" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#030B18] via-[rgba(3,11,24,0.3)] to-transparent" />
              <div className="absolute bottom-5 left-6 z-[2]">
                <h3 className="font-orbitron text-lg lg:text-xl font-bold tracking-[2px] text-white text-shadow-sm">{arch.title}</h3>
                <span className="font-outfit text-sm text-[#60A5FA] tracking-[2px] uppercase text-shadow">{arch.subtitle}</span>
              </div>
            </div>
            <div className="p-6">
              <p className="font-outfit text-lg lg:text-xl leading-relaxed text-white/60 font-light mb-5 text-shadow-sm">
                {arch.desc}
              </p>
              <div className="flex flex-wrap gap-2">
                {arch.tags.map((tag, j) => (
                  <span key={j} className="arch-tag text-xs">{tag}</span>
                ))}
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
